import { useEffect, useState } from "react";
import { ConfirmacaoProps } from "../../../interfaces/props/SaudeOnline/ConfirmacaoProps";
import { Button } from '@mui/material';
import { sxButton } from './sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faEdit } from '@fortawesome/free-solid-svg-icons';
import './styles.css';
import ContactModal from "./ContactModal";
import { TypeScheduleTabsEnum } from "../../../interfaces/enum/TypeScheduleTabsEnum";
import LoadingApp from "../../../components/LoadingApp";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import SucessContactEditModal from "./SucessContactEditModal";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

function Confirmacao(props: ConfirmacaoProps) {
    const [day, setDay] = useState<string>('');
    const [month, setMonth] = useState<string>('');
    const [year, setYear] = useState<number>(0);
    const [tel, setTel] = useState<string>('');
    const [cel, setCel] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [openEdit, setOpenEdit] = useState(false);
    const [openFeedback, setOpenFeedback] = useState(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const accessibility = useAccessibility();

    useEffect(() => {
        const getUser = async () => {
            setShowLoading(true)
            const benef = getBenef()!;
            setTel(benef.tel);
            setCel(benef.cel);
            setEmail(benef.email);
            setShowLoading(false);
        }

        if(props.selectedDate !== null){
            setDay(String(props.selectedDate.getDate()).padStart(2, '0'));
            setMonth(String(props.selectedDate.getMonth() + 1).padStart(2, '0'));
            setYear(props.selectedDate.getFullYear());
        }

        getUser();

    }, []);

    const goBack = () => {
        props.backStep(TypeScheduleTabsEnum.LocalDeExames, false);
    }

    const handleSave = (newTel: string, newCel: string, newEmail: string) => {
        setTel(newTel);
        setCel(newCel);
        setEmail(newEmail);
        setOpenEdit(false);
        setOpenFeedback(true)
    }

    const handleClose = () => {
        setOpenEdit(false);
    }

    const handleCloseModal = () => {
        setOpenFeedback(false);
    }

    const handleModal = () => {
        setOpenEdit(true);
    }

    const handleSchedule = () => {
        props.saveSchedule(tel, cel, email);
    }

    return (
        <div className="confirmation-holder">
            <SucessContactEditModal open={openFeedback} handleCloseModal={handleCloseModal}/>
            <LoadingApp showLoading={showLoading}/>
            <h2 className="confirmation-title" style={accessibility.textStyleAccessibility}>Confirmação da reserva do agendamento</h2>
            <div className="confirmation-info-holder" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                <div className="confirmation-info">
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Médico(a)</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.nomePessoa}</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Especialidade</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.descrEspec}</span>
                </div>
                <div className="confirmation-info">
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Cidade</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.cidade}</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Bairro</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.bairro}</span>
                </div>
                <div className="confirmation-info">
                    <span className="info-title" style={accessibility.textStyleAccessibility}>CEP</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.cep}</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Endereço</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.doctor.logradouro}, {props.doctor.numero}</span>
                </div>
                <div className="confirmation-info">
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Tipo de atendimento</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{props.typeOfAppointment}</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Horário</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{day}/{month}/{year} - {props.selectedHour?.diaSemana}-feira às {props.selectedHour?.hora}</span>
                </div>
            </div>

            <h2 className="confirmation-title" style={accessibility.textStyleAccessibility}>Confirme seus dados de contato</h2>
            <div className="confirmation-info-holder" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                <div className="confirmation-info">
                    <span className="confirmation-contact" style={accessibility.textStyleAccessibility}>Dados de contato</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Telefone</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{tel}</span>
                </div>
                <div className="confirmation-info">
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Celular</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{cel}</span>
                </div>
                <div className="confirmation-info confirmation-secondary" style={{ ...accessibility.contrastBorderAccessibility, ...accessibility.contrastStyle}}>
                    <span className="info-title" style={accessibility.textStyleAccessibility}>Email</span>
                    <span className="info-description" style={accessibility.textStyleAccessibility}>{email}</span>
                </div>
            </div>
            <button className="edit-contact" onClick={handleModal} style={accessibility.textStyleAccessibility}>
                <FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;<u>Alterar dados de contato</u>
            </button>
            <div className="hours-buttons">
                <Button 
                    variant="contained" 
                    size="large"
                    onClick={handleSchedule}
                    aria-label="confirmar agendamento"
                    sx={sxButton}
                    style={accessibility.buttonStyleAccessibility}
                    disabled={false}
                    fullWidth>
                    <span style={accessibility.buttonTextStyleAccessibility}>Confirmar</span>
                </Button>
            </div>
            <button 
                className="back-button" 
                onClick={goBack} 
                style={accessibility.textStyleAccessibility}
                aria-label="voltar para passo anterior"
            >
                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
            </button>
            <ContactModal open={openEdit} tel={tel} cel={cel} email={email} handleSave={handleSave} handleClose={handleClose}/>
        </div>
    )
}

export default Confirmacao;